import { jsx as _jsx } from "react/jsx-runtime";
export default function PriceSkeleton({ testId }) {
    return (_jsx("div", { className: "inline-flex flex-col items-end justify-center gap-1 self-stretch rounded-tr-lg rounded-br-lg p-1.5", "data-testid": testId, children: _jsx("div", { className: "relative w-20", children: _jsx("div", { className: "parking-search-results-price-loader" }) }) }));
}
